import { render, staticRenderFns } from "./PlacementSidebar.vue?vue&type=template&id=ed692d3c&scoped=true&"
import script from "./PlacementSidebar.vue?vue&type=script&lang=js&"
export * from "./PlacementSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PlacementSidebar.vue?vue&type=style&index=0&id=ed692d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed692d3c",
  null
  
)

export default component.exports